export default "__VITE_ASSET__DPpW74zj__"